import { memo } from 'react';
import { useTheme } from '@mui/material';
import DataDeletionIllustrationLight from './dataDeletion.svg?react';
import DataDeletionIllustrationDark from './dataDeletion_dark.svg?react';

export const DataDeletionIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <DataDeletionIllustrationDark aria-hidden="true" {...props} />;
    return <DataDeletionIllustrationLight aria-hidden="true" {...props} />;
  },
);
